import * as React from 'react';
import { TBoardId } from '../../../../../../../types/types';
import { PreviewHeaderHOC } from '../../../../preview/PreviewHeader/hocs/PreviewHeaderHOC/PreviewHeaderHOC';

export const getCardPreviewHeader = (
    boardId: TBoardId
): JSX.Element => {
    return (<PreviewHeaderHOC boardId={boardId}/>)
};
